import { PerfilNormalizado } from '../shared/enums/perfil-normalizado.enum';

export class Perfil {
    selected: boolean;
    constructor(
        public perfilId: number,
        public descricao: string,
        public nome: string,
        public nomeNormalizado: string,
        public isChecked: boolean
    ) { }

    public static parseToPerfilNormalizado(nomeNormalizado: string): PerfilNormalizado {
        nomeNormalizado = nomeNormalizado.toUpperCase();
        switch (nomeNormalizado) {
            case 'RESPONSAVEL': return PerfilNormalizado.Responsavel;
            case 'CADASTRO': return PerfilNormalizado.Cadastro;
            case 'ADMINISTRATIVO': return PerfilNormalizado.Administrativo;
            case 'FINANCEIRO': return PerfilNormalizado.Financeiro;
            case 'PRODUTO': return PerfilNormalizado.Beneficio;
            case 'COMPRA': return PerfilNormalizado.Pedido;
            case 'CARTAOFISICO': return PerfilNormalizado.CartaoFisico;
            case 'RELATORIO': return PerfilNormalizado.Relatorio;
            default: throw new Error(('Enum não contemplado')); break;
        }
    }
}
